import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const ShareDesktop = ({ copy, emailSubject }) => {
    return (
        <Styled.ShareDesktopWrapper>
            <Styled.IconRow>
                <Styled.ShareText>SHARE</Styled.ShareText>
                <Styled.FacebookIcon href="https://www.facebook.com/sharer/sharer.php?u=itv7sweepstake.itv.com">
                    <Styled.IconImage
                        src="/img/share/facebook.svg"
                        alt="Facebook Link"
                    />
                </Styled.FacebookIcon>
                <Styled.XIcon
                    href={`https://x.com/intent/post?original_referer=http%3A%2F%2Fitv7sweepstake.itv.com&related=ITV7&text=${encodeURIComponent(
                        copy
                    )}`}
                >
                    <Styled.IconImage src="/img/share/x.svg" alt="X Link" />
                </Styled.XIcon>
                <Styled.WhatsappIcon
                    href={`https://wa.me/?text=${encodeURIComponent(copy)}`}
                >
                    <Styled.IconImage
                        src="/img/share/whatsapp.svg"
                        alt="WhatsApp Link"
                    />
                </Styled.WhatsappIcon>
                <Styled.EmailIcon
                    href={`mailto:?subject=${encodeURIComponent(
                        emailSubject
                    )}&body=${encodeURIComponent(copy)}`}
                >
                    <Styled.IconImage
                        src="/img/share/email.svg"
                        alt="Email Link"
                    />
                </Styled.EmailIcon>
                <Styled.CopyIcon
                    onClick={() => navigator.clipboard.writeText(copy)}
                >
                    <Styled.IconImage
                        src="/img/share/copy-link.svg"
                        alt="Copy Link"
                    />
                </Styled.CopyIcon>
            </Styled.IconRow>
        </Styled.ShareDesktopWrapper>
    );
};

ShareDesktop.defaultProps = {};

ShareDesktop.propTypes = {
    copy: PropTypes.string.isRequired,
    emailSubject: PropTypes.string.isRequired
};

export default ShareDesktop;
